import { Collapse, Row, Text, theme } from '@/components';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectsSearchStore } from '../../_stores/projects-search-store';
import { NestedExpenditureBudgetPurposeIdsColField } from '../_common/fields/NestedExpenditureBudgetPurposeIdsColField';
import { NestedOtherResponsibleOrganizationIdsColField } from '../_common/fields/NestedOtherResponsibleOrganizationIdsColField';
import { PeriodColField } from '../_common/fields/PeriodColField';

const KEY = 'advance-filter-project-panel';

export const AdditionalSearch: FC = () => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const { openAdditionalAccordion, setOpenAdditionalAccordion } =
    useProjectsSearchStore();

  return (
    <Collapse
      activeKey={openAdditionalAccordion ? KEY : undefined}
      expandIcon={({ isActive }) =>
        isActive ? (
          <DownOutlined style={{ color: token.colorPrimary, fontSize: 12 }} />
        ) : (
          <RightOutlined style={{ color: token.colorPrimary, fontSize: 12 }} />
        )
      }
      style={{
        background: token.colorBgBase,
        borderRadius: 0,
      }}
      onChange={(e) => {
        setOpenAdditionalAccordion(!!e.length);
      }}
      items={[
        {
          key: KEY,
          id: 'advance-filter-project-panel',
          label: <Text color="primary" text={t('project-search-advance')} />,
          style: { borderRadius: 0, background: token.colorBorderBg },
          children: (
            <Row gutter={16}>
              <PeriodColField />
              <NestedOtherResponsibleOrganizationIdsColField />
              <NestedExpenditureBudgetPurposeIdsColField />
            </Row>
          ),
        },
      ]}
    />
  );
};
